module.exports = __webpack_public_path__ + "img/classic.513b445.webp";